export default __webpack_public_path__ + "static/media/gold@3x.ecc15ee9.png";